var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"particle-container"},_vm._l((_vm.particles),function(particle,index){return _c('div',{key:index,staticClass:"particle",style:(particle.style)})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }